import React from 'react';
import { useFormatter } from 'shared/formatters';

interface Props {
  title: string;
  date?: Date;
}

export default function OverviewDateColumn({ title, date }: Props) {
  const { formatDateTime } = useFormatter();

  if (!date) {
    return null;
  }

  return (
    <div>
      <span className="user-access-sharing-overview-card__date-title">
        {title}
      </span>

      <div className="user-access-sharing-overview-card__date">
        {formatDateTime(date)}
      </div>
    </div>
  );
}
